import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import { handleError } from 'reducers/ErrorReducer';
import Checkbox2 from 'components/Checkbox2';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { genColHeaderName } from 'utils/functions';
import { showSpinner, hideSpinner } from 'reducers/UiReducer';
import { getService } from 'reducers/service';

const useStyles = makeStyles((theme) => ({
  error: {
    marginBottom: 16,
  },
  stats: {
    '& td': {
      fontSize: 16,
      paddingRight: 16,
    },
  },
  addressDetails: {
    display: 'inline-block',
    padding: '8px 16px',
    fontSize: 18,
    marginBottom: 16,
    '& span': {
      display: 'inline-block',
      color: theme.palette.secondary.main,
      marginRight: 8,
    },
    '& b': {
      fontWeight: 'bold',
    },
  },
  horizontalWrapper: {
    display: 'flex',
    flexDirection: 'row',
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    width: '100%',
    padding: '10px 0',
  },
  personContainer: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '350px', // each block width
    marginRight: '20px',
    border: '1px solid #ddd',
    borderRadius: '8px',
    padding: '12px',
  },
  wrapLabel: {
    display: 'inline-block',
    maxWidth: '100%',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
  },
  statsTitle: {
    fontWeight: 500,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
  },
}));

function ReviewMultipleMerge(props) {
  const {
    source,
    target,
    data,
    setLoading,
    personData,
    setPersonData,
    deleteSources,
    setDeleteSources,
  } = props;
  const [stats, setStats] = useState([]);
  const mountedRef = useRef(true);
  const classes = useStyles();

  useEffect(() => {
    processTargetData();
    source?.forEach((_, index) => {
      checkStats(index);
    });

    return () => {
      mountedRef.current = false;
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!source || source.length === 0) return;
    const defaults = {};
    source.forEach((_, index) => {
      defaults[index] = true;
    });
    setDeleteSources(defaults);
  }, [source]);

  const processTargetData = () => {
    const newData = { ...target };
    data.forEach((i) => {
      const key = i.field;
      const val = i.isTargetVal ? i.targetVal : i.sourceVal;
      newData[key] = val;
    });
    setPersonData(newData);
  };

  const checkStats = async (index) => {
    const service = getService('rms-person-merge');
    setLoading(true);
    const sourcePtsPersonID = source[index].ptsPersonID;
    const targetPtsPersonID = target.ptsPersonID;
    try {
      const result = await service.find({
        query: { sourcePtsPersonID, targetPtsPersonID },
      });
      if (!result || !mountedRef.current) return;
      const newStats = Object.entries(result.data).map(([key, val]) => ({
        key,
        val,
      }));
      setStats((prev = []) => {
        const updated = [...prev];
        updated[index] = newStats;
        return updated;
      });
    } catch (err) {
      props.handleError(err);
    } finally {
      setLoading(false);
    }
  };

  const renderPerson = () => {
    if (!personData) return '';
    const { PersonID, FullName } = personData;
    return (
      <Paper variant="outlined" className={classes.addressDetails}>
        <span>{PersonID}</span> <b>{FullName}</b>
      </Paper>
    );
  };

  const renderDataUpdates = (index) => {
    if (!stats || !stats[index]) return '';
    return (
      <div className={classes.stats}>
        <h5 className={classes.statsTitle}>Records to be replaced ({source[index].FullName}):</h5>
        <table>
          <tbody>
            {stats[index].map((row) => (
              <tr key={row.key}>
                <td>{genColHeaderName(row.key)}:</td>
                <td>{row.val}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const renderDeleteSource = (index) => {
    return (
      <div>
        <FormControlLabel
          control={
            <Checkbox2
              checked={!!deleteSources[index]}
              onChange={(ev, val) =>
                setDeleteSources((prev) => ({
                  ...prev,
                  [index]: val,
                }))
              }
            />
          }
          label={
            <span className={classes.wrapLabel}>
              Delete Person - {source[index].FullName} {source[index].PersonID}
            </span>
          }
        />
      </div>
    );
  };

  return (
    <>
      {renderPerson()}
      <div className={classes.horizontalWrapper}>
        {source?.map((source, index) => (
          <div key={index} className={classes.personContainer}>
            {renderDeleteSource(index)}
            {renderDataUpdates(index)}
          </div>
        ))}
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  dictionary: state.dictionary,
});

export default connect(mapStateToProps, { handleError, showSpinner, hideSpinner })(
  ReviewMultipleMerge
);
